import angular from 'angular';
import {
    ITipoArquivoCreatePayload,
    ITipoArquivoResponse,
    ITipoArquivoUpdatePayload,
} from './models/tipo-arquivos.service.model';
import { NsjRoutingType } from '@core/nsj-core';

export class TipoArquivosService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public loading_deferred: angular.IDeferred<unknown> | null = null;
    public listBusy = false;

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: NsjRoutingType,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService,
    ) {}

    public getList(constructors: Record<string, any> = {}) {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loading_deferred = this.$q.defer();
        this.listBusy = true;

        return this.$q<ITipoArquivoResponse[]>((resolve, reject) => {
            this.$http
                .get<ITipoArquivoResponse[]>(
                    this.nsjRouting.generate('meurh_tiposarquivos_index', constructors, true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_index_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_index_error', error);
                    reject(error);
                })
                .finally(() => {
                    this.listBusy = false;
                });
        });
    }

    public create(payload: ITipoArquivoCreatePayload) {
        this.loading_deferred = this.$q.defer();

        return this.$q<ITipoArquivoResponse>((resolve, reject) => {
            this.$http
                .post<ITipoArquivoResponse>(
                    this.nsjRouting.generate('meurh_tiposarquivos_post', {}, true),
                    payload,
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_post_loaded', response);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_post_error', error);
                    reject(error);
                });
        });
    }

    public update(identifier: string, payload: ITipoArquivoUpdatePayload) {
        this.loading_deferred = this.$q.defer();

        return this.$q<ITipoArquivoResponse>((resolve, reject) => {
            this.$http
                .put<ITipoArquivoResponse>(
                    this.nsjRouting.generate('meurh_tiposarquivos_put', { id: identifier }, true),
                    payload,
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_put_loaded', response);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_put_error', error);
                    reject(error);
                });
        });
    }

    public delete(identifier: string) {
        this.loading_deferred = this.$q.defer();

        return this.$q<void>((resolve, reject) => {
            this.$http
                .delete<void>(
                    this.nsjRouting.generate('meurh_tiposarquivos_delete', { id: identifier }, true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_delete_loaded', response);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_delete_error', error);
                    reject(error);
                });
        });
    }

    public get(identifier: string) {
        this.loading_deferred = this.$q.defer();

        return this.$q<ITipoArquivoResponse>((resolve, reject) => {
            this.$http
                .get<ITipoArquivoResponse>(
                    this.nsjRouting.generate('meurh_tiposarquivos_get', { id: identifier }, true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_get_loaded', response);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('meurh_tiposarquivos_get_error', error);
                    reject(error);
                });
        });
    }
}

angular.module('main').service('TipoArquivosService', TipoArquivosService);
